import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-ombudsperson', templateUrl: './ombudsperson.component.html', styleUrls: ['./ombudsperson.component.scss'] })
export class OmbudspersonComponent implements OnInit {
  pdfSrc = '/assets/pdf/grievances/Ombudsperson.pdf';
  constructor() { }
  ngOnInit(): void { }
}
